import { connect } from "react-redux";
import DevicesWidget from "./DevicesWidget"
import { fetchAllDevices } from "../../../../redux/actions/device_actions"


const mapStateToProps = (state) => {
    return ({
        devices: Object.values(state.devices)
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchAllDevices: (cancelToken) => dispatch(fetchAllDevices(cancelToken))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(DevicesWidget);
